import { RISK_QUESTION_IDS } from '../../ui/shared/quiz-slides/quiz-risk-slides';
import { safeStorage } from './safe-storage';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift();
}

const getFbclid = search => {
    const searchParams = new URLSearchParams(search);

    return searchParams.get('fbclid');
};

const getMetadata = (search, initialPrelander = '', userResponses = null) => {
    const metadata = { screenWidth: window.screen.width, screenHeight: window.screen.height };
    const searchParams = new URLSearchParams(search);
    const fbclid = searchParams.get('fbclid');
    const creative = searchParams.get('utm_content') || searchParams.get('ad_name');
    const creativeId = searchParams.get('ad_id');
    const campaignName = searchParams.get('utm_campaign') || searchParams.get('campaign_name');
    const campaignId = searchParams.get('campaign_id');
    const adset = searchParams.get('adset_name');
    const adsetId = searchParams.get('adset_id');
    const placement = searchParams.get('placement');
    const fbp = getCookie('_fbp');
    const visitId = safeStorage.getItem('visit_id');

    if (fbclid) {
        metadata.fbclid = fbclid;
    }

    if (fbp) {
        metadata.fbp = fbp;
    }

    if (initialPrelander) {
        metadata.lastPrelander = initialPrelander;
    }

    if (creative) {
        metadata.creative = creative;
    }

    if (creativeId) {
        metadata.creativeId = creativeId;
    }

    if (campaignName) {
        metadata.campaignName = campaignName;
    }

    if (campaignId) {
        metadata.campaignId = campaignId;
    }

    if (adset) {
        metadata.adset = adset;
    }

    if (adsetId) {
        metadata.adsetId = adsetId;
    }

    if (placement) {
        metadata.placement = placement;
    }

    if (visitId) {
        metadata.visitId = visitId;
    }

    if (Array.isArray(userResponses)) {
        const riskSurveyResponses = RISK_QUESTION_IDS
            .map(id => userResponses.find(response => response.questionId === id))
            .filter(Boolean)
            .map(({ question, text }) => ({ question, answer: text }));

        if (riskSurveyResponses.length) {
            metadata.riskSurveyResponses = riskSurveyResponses;
        }
    }

    return metadata;
};

export {
    getMetadata,
    getFbclid
};
